import { Component } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-ineligibility',
    templateUrl: './customer-ineligibility.component.html',
    styleUrls: ['./customer-ineligibility.component.scss'],
    standalone: false
})
export class CustomerIneligibilityComponent extends CfetBaseComponent {

  constructor() { super(); }

}
